import React, { FC, useState, useEffect, useCallback } from "react";
import {
  Title,
  useNotify,
  useRefresh,
  useTranslate,
  Notification,
  useDataProvider,
  warning,
  useCreate,
  minLength,
} from "react-admin";
import {
  Button,
  createStyles,
  Divider,
  Grid,
  makeStyles,
  TextField,
  Theme,
  Tooltip,
  FormControlLabel,
  Checkbox,
  Box,
  MenuItem,
  FormHelperText,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import { useForm, SubmitHandler, useController } from "react-hook-form";

type Inputs = {
  name: string;
  apiKey: string;
  encryptionKey: string;
  id: string;
};

const Create: FC = () => {
  const notify = useNotify();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const history = useHistory();
  const { id } = useParams();

  const [companyData, setCompanyData] = useState<any>([]);

  useEffect(() => {
    dataProvider.getOne(
      "company",
      {
        id: id,
      },
      {
        onSuccess: async (response) => {
          setCompanyData(response.data);
        },
      }
    );
  }, []);

  const [name, setName] = useState<string>("");
  const [idd, setIdd] = useState<string>("");
  const [encryptionKey, setEncryptionKey] = useState<string>("");
  const [apiKey, setApikey] = useState<string>("");

  useEffect(() => {
    setName(companyData?.name);
    setIdd(companyData?.id);
    setEncryptionKey(companyData?.encryption_key);
    setApikey(companyData?.apikey);
  }, [companyData]);

  console.log(companyData, "companyDatacompanyData");

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    formState: { errors, isDirty },
  } = useForm<Inputs>();
  const OnSubmit = () => {
    const update = {
      name: name,
      encryption_key: encryptionKey,
      id: idd,
      apikey: apiKey,
    };

    dataProvider.update(
      "company",
      {
        id: id,
        data: update,
        previousData: {
          id: id,
        },
      },
      {
        onSuccess: () => {
          const timer: ReturnType<typeof setTimeout> = setTimeout(
            () => refresh(),
            1000
          );
          notify("Your Company was successfully updated", "info");
          history.push("/company");
        },
        onFailure: () => {
          notify("Error: Your Company was not successfully updated", "warning");
        },
      }
    );
  };

  return (
    <Box sx={{ pl: 5, pt: 12 }}>
      <Title title="Invite User" />
      <Box>
        <form onSubmit={handleSubmit(OnSubmit)}>
          <Grid container spacing={1}>
            <Grid item md={2}>
              <TextField
                id="name"
                label="Name"
                placeholder="Enter Name"
                value={name}
                InputLabelProps={{ shrink: true, required: true }}
                onChange={(e: any) => {
                  setName(e.target.value);
                }}
                variant="outlined"
                fullWidth
                required
              />
            </Grid>
            <Grid item md={2}>
              <TextField
                id="id"
                label="Company Code"
                placeholder="Enter Company Code"
                value={idd}
                InputLabelProps={{ shrink: true, required: true }}
                onChange={(e: any) => {
                  setIdd(e.target.value);
                }}
                variant="outlined"
                fullWidth
                type="text"
              />
            </Grid>
          </Grid>
          <Box sx={{ pb: 3 }}></Box>
          <Grid container spacing={2}>
            <Grid item xs={5} md={2}>
              <TextField
                id="apiKey"
                label="Api Key"
                placeholder="Enter Api Key"
                value={apiKey}
                InputLabelProps={{ shrink: true, required: true }}
                onChange={(e: any) => {
                  setApikey(e.target.value);
                }}
                variant="outlined"
                fullWidth
                type="text"
              />
            </Grid>
            <Grid item xs={5} md={2}>
              <TextField
                id="encryptionKey"
                label="Encryption Key"
                placeholder="Enter Encryption Key"
                value={encryptionKey}
                InputLabelProps={{ shrink: true, required: true }}
                onChange={(e: any) => {
                  setEncryptionKey(e.target.value);
                }}
                variant="outlined"
                fullWidth
                type="text"
              />
            </Grid>
          </Grid>
          <Box sx={{ p: 4 }}>
            <Divider />
          </Box>
          <Grid container spacing={2}>
            <Grid item md={3}>
              <Button
                type="button"
                onClick={handleSubmit(OnSubmit)}
                variant="contained"
                color="primary"
                size="large"
                disabled={
                  name == "" || encryptionKey == "" || apiKey == "" || id == ""
                    ? true
                    : false
                }
              >
                Submit
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Box>
  );
};

export default Create;
